import { Container } from '@mui/material';
import { Box } from '@mui/system';
import { AppContext } from 'pages/_app';
import { PropsWithChildren, useContext } from 'react';
import { useContainerStore } from 'stores/container-store';

interface AppContainerProps {
  disableFooter: boolean;
  extendedHeader: boolean;
  noContainerPadding: boolean;
  fullScreenNoLayout: boolean;
}

const AppContainer = ({
  disableFooter,
  extendedHeader,
  noContainerPadding,
  fullScreenNoLayout,
  children,
}: PropsWithChildren<AppContainerProps>) => {
  const isApp = useContext(AppContext)?.isApp;
  const { notificationsHeight } = useContainerStore((state) => ({
    notificationsHeight: state.notificationsHeight,
  }));

  return (
    <>
      {!fullScreenNoLayout ? (
        <Container
          maxWidth="xl"
          id="content-container"
          sx={{
            pt: 2,
            px: { xs: noContainerPadding ? 0 : 3 },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              pb: isApp ? 2.5 : 0,
              minHeight: disableFooter
                ? isApp
                  ? `calc(100vh - ${notificationsHeight}px)`
                  : `calc(100vh - 161px - ${notificationsHeight}px)`
                : extendedHeader
                  ? {
                      xs: `calc(100vh - 292px - 52px - ${notificationsHeight}px)`,
                      xl: `calc(100vh - 292px - ${notificationsHeight}px)`,
                    }
                  : {
                      xs: `calc(100vh - 277px - 95px - ${notificationsHeight}px)`,
                      xl: `calc(100vh - 250px - 64px - ${notificationsHeight}px)`,
                    },
            }}
          >
            {children}
          </Box>
        </Container>
      ) : (
        <div>{children}</div>
      )}
    </>
  );
};

export default AppContainer;
